var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-alert',{staticClass:"copy-notice",attrs:{"value":_vm.copyFlag,"dense":"","type":"info","transition":"scroll-x-reverse-transition"}},[_vm._v(" API KEYをコピーしました。 ")])}
var staticRenderFns = []

export { render, staticRenderFns }